// extracted by mini-css-extract-plugin
export default {"container":"panel_container__+7cHA","header":"panel_header__xG3IM"};